var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" duration: "+_vm._s(_vm.duration)+" "),(_vm.duration > 0)?_c('v-range-slider',{attrs:{"label":"Trimmer","min":"0","max":_vm.duration,"thumb-label":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }